{
  "currentActivity": "Current Activity",
  "online": "online",
  "active": "active",
  "deviceMarkerUpdating": "Updating...",
  "doNotShowThisAgain": "Do not show this again",
  "inFieldWithFieldName": "In field ${{fieldName}}",
  "locateDevice": {
    "helpBody": "In order to be located, a device must be powered on and have cellular reception.",
    "coordinatesWithLongitudeAndLatitude": "Coordinates: {{longitude}}, {{latitude}}",
    "copyLocation": "Copy",
    "goTo": "Go to",
    "linkTo": "Locate",
    "noLocationMessage": "This device has no gps location. Please ensure it is powered on and has cellular reception",
    "noLocationTitle": "No GPS Location",
    "openInApple": "Open in Apple Maps",
    "openInGoogleMaps": "Open in Google Maps",
    "title": "Device Location"
  },
  "locateDeviceCooordinatesLabel": "Coordinates",
  "locateField": {
    "appleMaps": "Go To (Apple Maps)",
    "errorMessage": {
      "message": "Unable to calculate field center. Please contact support.",
      "title": "Something Went Wrong"
    },
    "googleMaps": "Go To (Google Maps)"
  },
  "mapSettingsFieldColor": "Field Color",
  "mapSettingsMapTypeId": "Map Style",
  "mapSettingsTitle": "Map Settings",
  "quickActions": {
    "connectDevices": "Connect Devices",
    "createField": "New Field",
    "manageSchedules": "Manage Schedules",
    "mapSettings": "Map Settings",
    "newDevice": "New Device",
    "title": "Actions",
    "viewDeviceActivity": "View Device Activity",
    "viewSchedules": "View Schedules"
  },
  "selectedDevice": {
    "commandsLink": "Controls",
    "deviceProfileLink": "Manage",
    "notifications": "Notifications"
  },
  "selectedReelRunTitle": "Reel Run",
  "setReelDistance": {
    "distanceMmCurrent": {
      "errors": {
        "max": "This value is too higher than the allowable threshold for manual distance overrides"
      },
      "labelWithUnitLabel": "Distance Remaining ({{unitLabel}})"
    },
    "distanceMmMax": {
      "labelWithUnitLabel": "Distance Extended ({{unitLabel}})"
    },
    "errorMessage": "Our service cannot process your request at the moment. Please try again.",
    "instructions": "Override the run distances?",
    "linkTo": "Set Distance",
    "noActiveRunsMessage": "No active reel run found for this device.",
    "noActiveRunsTitle": "No Active Reel Run",
    "notRetractingMessage": "Cannot set the distance of a reel that isn't retracting.",
    "successMessage": "Changes saved. Please wait for an update...",
    "title": "Set Reel Distance",
    "warning": "This cannot be undone"
  },
  "setRunDirection": {
    "flipButton": "Flip",
    "instructions": "Override the direction of the run?",
    "linkTo": "Set Direction",
    "title": "Set Reel Run Direction"
  },
  "setApplicationType": {
    "instructions": "What did this run apply? This overrides the application type from the reel's configuration for this run only.",
    "linkTo": "Set Application Type",
    "title": "Set Run Application Type"
  },
  "setRunField": {
    "automaticOption": "Automatic (GPS)",
    "instructions": "Assign this run to a field. Automatic uses the run's GPS end point; picking a field pins the run to it and uses that field's row direction.",
    "linkTo": "Set Field",
    "title": "Set Run Field"
  },
  "manageReelRun": "Manage Reel Run",
  "deviceActivityHide": "Hide Activity",
  "deviceActivityLabel": "Activity",
  "deviceActivityShow": "Show Activity",
  "heatmapLayersHide": "Hide heatmap",
  "heatmapLayersLabel": "Heatmap",
  "heatmapLayersShow": "Show heatmap",
  "heatmapLegendTitle": "Application Depth - Last 7 Days",
  "showDevices": "Devices",
  "showFields": "Fields",
  "showReelRuns": "Reel Runs",
  "showTimeline": "Timeline",
  "title": "Status Map",
  "unknownDevice": "Unknown Device",
  "unknownFields": {
    "description": "Reel runs will not be visible in the unless they fall inside the boundaries of one of your fields.",
    "dismissButton": "not now",
    "drawFieldButton": "Draw Field Button",
    "title": "Unknown Fields",
    "warningText": "FarmHQ received reel runs for the following devices in unknown fields:"
  }
}
